<template>
  <div :class="$style.click">
    <div :class="$style.container" @click="isModalOpen = true">
      <p>{{ $t("notice", { closingTime }) }}</p>
    </div>
    <modal-app-closing v-if="isModalOpen" @cancel="isModalOpen = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalAppClosing from '@/components/ModalAppClosing.vue'

export default {
  components: {
    ModalAppClosing
  },
  data () {
    return {
      isModalOpen: false
    }
  },
  computed: {
    ...mapGetters({
      closingTime: 'closingTimeLocale'
    })
  },
  i18n: {
    messages: {
      ko: {
        notice: '서비스가 서울 시간 기준 {closingTime}에 종료됩니다.'
      },
      en: {
        notice: 'The service ends at {closingTime} Seoul time.'
      }
    }
  }
}
</script>

<style module>
.container {
  background: #ffe8e6;
  color: #912d2b;
  text-align: center;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 700;
}

.click {
  cursor: pointer;
}
</style>
